import React from "react";
import { Link } from "react-router-dom";
import type { PermissionLevel } from "./AuthProvider";
import { useAuth } from "./AuthProvider";
import { homePathForPermissions } from "./routeAccess";

export function RequirePermission({
  moduleId,
  level = "view",
  message = "Your account is signed in, but does not have access for this area.",
  children,
}: {
  moduleId: string;
  level?: PermissionLevel;
  message?: string;
  children: React.ReactNode;
}) {
  const { loading, hasPermission } = useAuth();
  const homePath = homePathForPermissions(hasPermission);

  if (loading) {
    return (
      <div className="center">
        <div className="card">
          <h3>Loading...</h3>
          <p className="muted">Checking permissions.</p>
        </div>
      </div>
    );
  }

  if (!hasPermission(moduleId, level)) {
    return (
      <div className="center">
        <div className="card">
          <h3>Access denied</h3>
          <p className="muted">{message}</p>
          <Link to={homePath} className="btn secondary">Go home</Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
